const ENV = {
  ENVIRONMENT: process.env.NODE_ENV,
  PRODUCTION: process.env.NODE_ENV === 'production',
  DEVELOPMENT: process.env.NODE_ENV === 'development',
  HOSTNAME: window.location.hostname,
  ANALYTICS_ENABLED:
    process.env.NODE_ENV === 'production' &&
    window.location.hostname === 'app.spotter.bot'
};
export { ENV };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/environment.ts